import { useContext } from 'react';
import CategoryContext from 'contexts/ListingType/components/CategoryPage/components/CategoryContext';

export default function useTipsheet() {
    const { state } = useContext(CategoryContext);
    const tipsheet =
        state &&
        state.category &&
        state.category.context &&
        state.category.context.tipsheet
            ? state.category.context.tipsheet
            : null;

    return [tipsheet];
}
